module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/careers-art-main-7ee5545f94067b0c95f6e3ba4bd25bc5.jpg";